import React, { Suspense, useState, useEffect, useRef } from "react";
import { Layout, theme, ConfigProvider } from "antd";
import { Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { routes } from "../../routes/routes";
import { useNavigate, useLocation } from "react-router-dom"; // Import useNavigate
import { useActivityLogger } from "../../hooks/useActivityLogger";

import {
  setUserDetails,
  fetchBasicConfig,
  getMasterList,
  getMessageLibrary,
  updateUsersList,
  setConsoleData,
  setUTS,
} from "@store/actions/basicConifgAction";
import {
  customrolesuam,
  getallmasterlist,
  getallmasterlistbycountry,
  messagelibrary,
  nonuamusers,
  loginapi,
  applicationconf
} from "@constants/endpoints";
import SidebarComponent from "../sidebar/SidebarComponent";
import HeaderComponent from "../header/HeaderComponent";
import ErrorBoundary from "../errorboundary/ErrorBoundary";
import LoaderComponent from "../loader/LoaderComponent";
import AlertComponent from "../alerts/AlertComponent";
import PrivateRoute from "./PrivateRoute";
import { clearCache } from "@store/actions/basicConifgAction.js";
import { postData, getData } from "@services/apiConfig";
import usePageTracking from "@hooks/usePageTracking";
import FooterComponent from "../footer/FooterComponent";
const { Content } = Layout;

const classNames = {
  root: "custom-modal-root",
  wrap: "custom-modal-wrap",
  mask: "custom-modal-mask",
  centered: "custom-modal-centered",
  close: "custom-modal-close",
};

const LayoutComponent = () => {
  usePageTracking();
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const themeColor = useSelector(
    (state) => state.basicConfigReducer?.theme || "white"
  );

  const userDetailReducer = useSelector(
    (state) => state.basicConfigReducer?.userdetails || null
  );

  const consoleData = useSelector(
    (state) => state.basicConfigReducer?.console || null
  );
  const [collapsed, setCollapsed] = useState(false);
  const [dashboardPages, setDashboardPages] = useState([]);
  const [loginPages, setLoginPages] = useState([]);
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  //session expiry warning
  const [remainingTime, setRemainingTime] = useState(null);
  const [isPopupShown, setIsPopupShown] = useState(false); // Track if popup is shown
  const noClickCount = useRef(0); // Counter for "No" clicks
  const [canShowPopup, setCanShowPopup] = useState(true); // Flag to track popup visibility
  const isSession = consoleData?.isSession || null;
  const [showChatbot, setShowChatbot] = useState(false);
  const location = useLocation()
  const { logCustomActivity } = useActivityLogger();
  useEffect(() => {
    if (location) {
      logCustomActivity({ type: "page-load", url: window.location.href })
    }
  }, [location])
  useEffect(() => {
    const intervalId = setInterval(() => {
      const uts = parseInt(consoleData?.uts, 10); // Retrieve uts time as a number (timestamp)
      const currentTime = Date.now(); // Current time in milliseconds
      const expiryTime = uts + 25 * 60 * 1000; // 25 minutes after login in milliseconds
      if (currentTime > expiryTime && canShowPopup && !isPopupShown) {
        // If current time is greater than or equal to 25 minutes from login, show alert
        showAlert();
        setIsPopupShown(true); // Set flag to true to ensure the popup is shown only once
      } else if (currentTime <= expiryTime) {
        // Only reset if we are still within the valid time frame
        setIsPopupShown(false);
        noClickCount.current = 0; // Reset the "No" click count
        const timeRemaining = expiryTime - currentTime;
        setRemainingTime(timeRemaining);
      }
    }, 1000); // Runs every second

    return () => {
      clearInterval(intervalId); // Clean up interval on component unmount
    };
  }, [isPopupShown, canShowPopup]);

  const extendSession = async () => {
    const username = consoleData?.email;
    const token = consoleData?.token;
    let filteredStr = "";

    // Remove every 6th character block (1 original + 5 random characters)
    for (let i = 0; i < token.length; i += 6) {
      // Keep the original characters, skip the 5 extra ones
      filteredStr += token[i];
    }

    // Reverse the filtered string to recover the original value
    const password = filteredStr.split("").reverse().join("");

    let body = { username, password };
    try {
      let payload = {
        url: loginapi,
        body: body,
        baseName: "core",
      };
      const response = await postData(payload);
      // Check if the response status is successful (e.g., 200 or 201)
      if (response.status === 200 || response.status === 201) {
        dispatch(setUTS(response.uts));
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.log("error in relogin", error);
      return false;
    }
  };

  // Function to reset the session expiry check after extending the session
  const resetSessionExpiryCheck = () => {
    setIsPopupShown(false); // Ensure popup is closed
    noClickCount.current = 0; // Reset the "No" click counter if session is extended
    setCanShowPopup(false); // Allow popup to appear again when needed
  };

  const showAlert = () => {
    AlertComponent({
      type: "confirm",
      title: "Session Expiry Warning",
      text: "Your session will expire in the next 5 minutes. Do you want to continue?",
      icon: "warning",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      onConfirm: () => {
        let res = extendSession();
        if (res) {
          resetSessionExpiryCheck();
        }
      },
      onCancel: () => {
        noClickCount.current += 1;
        if (noClickCount.current >= 2) {
          setCanShowPopup(false); // Prevent showing the popup again
        }
        setIsPopupShown(false); // Close the popup
      },
    });
  };

  const getRoutes = (routes) => {
    const privateRoutes = routes.filter((route) => route.private);
    const nonPrivateRoutes = routes.filter((route) => !route.private);
    return { privateRoutes, nonPrivateRoutes };
  };

  useEffect(() => {
    if (localStorage.getItem("consoleSession")) {
      localStorage.removeItem("consoleSession");
    }
    
    console.log("userDetailReducer", userDetailReducer)
    if (!userDetailReducer) {
      setUserLoggedIn(false);
      // navigate('/login')  
    } else {
      console.log(userDetailReducer)
      // setUserLoggedIn(process.env.NODE_ENV === "development" ? false: true);
      setUserLoggedIn(true)
      resetConsoleStorage();
      const groups = userDetailReducer.groups || [];
      const roleName = groups[0]
      // groups[0] && ["hieadmin", "orgadmin"].includes(groups[0].toLowerCase())
      //   ? groups[0] + "1"
      // : groups[0];
      const pRoleName = ["hieadmin", "orgadmin","superuser"].includes(roleName) ? undefined : groups?.[1];

      let thirdRoleName;
      if (groups[2]) {
        thirdRoleName = groups[2];
      }

      dispatch(
        fetchBasicConfig({
          url: `${customrolesuam}?rolename=${roleName}`,
          action: "sidebar",
          //customParams: { roleName, pRoleName }
          customParams: {
            roleName,
            //pRoleName: pRoleName === "Co-Admin" ? "HieAdmin" : pRoleName, //TODO need to handle
            pRoleName,
            thirdRoleName,
          },
        })
      );
    }


    let confkey = "showChatbotIcon";
    const payload = {
      url: `${applicationconf}?confkey=${confkey}`, // Dynamically include confkey
    };

    getData(payload)
      .then((res) => {
        let chataccessflag = res.confvalue;
        setShowChatbot(chataccessflag)
      })
      .catch((error) => {
        console.error("Error fetching application configuration:", error);
      });


  }, [dispatch, userDetailReducer]);

  const resetConsoleStorage = () => {
    if (sessionStorage.getItem("console")) {
      const cData = JSON.parse(sessionStorage.getItem("console"));
      dispatch(setConsoleData(cData));
      sessionStorage.removeItem("console");
    }
  }

  useEffect(() => {
    resetConsoleStorage();
    const { privateRoutes, nonPrivateRoutes } = getRoutes(routes);
    console.log("privateRoutes", privateRoutes);
    console.log("nonPrivateRoutes", nonPrivateRoutes);
    setDashboardPages(privateRoutes);
    setLoginPages(nonPrivateRoutes);

    dispatch(setUserDetails());
    if (isSession === null || isSession !== "active") {
      dispatch(
        getMasterList({ url: `${getallmasterlist}`, action: "masterList" })
      );
    }
    dispatch(getMessageLibrary({ url: messagelibrary }));
  }, []);

  useEffect(() => {
    if (isSession === "active") {
      //This is to update the users, like HieAdmin which are not created using UAM module, into the DWH
      //dispatch(updateUsersList({ url: nonuamusers }));
      let countryid = userDetailReducer?.countryid;
      let userid = consoleData.uid || "";
      dispatch(
        getMasterList({
          url: `${getallmasterlistbycountry}?countryid=${countryid}&userid=${userid}`,
          action: "masterList",
        })
      );
    }
  }, [dispatch, userLoggedIn]);

  const clearCacheAndReload = () => {
    dispatch(clearCache());

    // Add a delay to ensure persisted store is cleared before reload
    setTimeout(() => {
      window.location.reload();
    }, 1);
  };

  return (
    <Layout>
      {userLoggedIn ? (
        <>
          <SidebarComponent
            collapsed={collapsed}
            setCollapsed={() => setCollapsed(!collapsed)}
          />
          <ConfigProvider
            theme={{
              algorithm:
                themeColor === "dark"
                  ? [theme.darkAlgorithm]
                  : [theme.defaultAlgorithm],
            }}
            modal={{
              classNames,
              styles: {
                mask: {
                  backdropFilter: "blur(10px)",
                },
              },
            }}
            drawer={{
              styles: {
                mask: {
                  backdropFilter: "blur(10px)",
                },
              },
            }}
          >
            <Layout
              className="site-layout"
              style={{ marginLeft: collapsed ? 80 : 250, height: "100%" }}
            >
              <HeaderComponent
                collapsed={collapsed}
                setCollapsed={() => setCollapsed(!collapsed)}
                clearCacheAndReload={clearCacheAndReload}
              />
              <Content
                style={{
                  paddingTop: 10,
                  paddingLeft: 20,
                  paddingRight: 20,
                  minHeight: 280,
                  overflow: "initial",
                }}
              >
                <div
                  style={{ minHeight: "calc(100vh - 45px)", overflow: "auto" }}
                >
                  <ErrorBoundary>
                    <Suspense fallback={<LoaderComponent />}>
                      <Routes>
                        {dashboardPages.map((route) =>
                          route.children?.map((childRoute) => (
                            <Route
                              key={childRoute.key}
                              path={childRoute.path}
                              element={
                                <ErrorBoundary>
                                  <PrivateRoute
                                    element={childRoute.element}
                                    path={childRoute.path}
                                  />
                                </ErrorBoundary>
                              }
                              errorElement={<ErrorBoundary />}
                            />
                          ))
                        )}
                      </Routes>
                    </Suspense>
                  </ErrorBoundary>
                </div>

              </Content>
              {showChatbot && (<FooterComponent />)}

            </Layout>
          </ConfigProvider>
        </>
      ) : (
        <ConfigProvider
          theme={{
            algorithm:
              themeColor === "dark"
                ? [theme.darkAlgorithm]
                : [theme.defaultAlgorithm],
          }}
        >
          <Layout className="site-layout" style={{ height: "100%" }}>
            <Content style={{ minHeight: 280, overflow: "initial" }}>
              <div
                style={{ minHeight: "calc(100vh - 45px)", overflow: "auto" }}
              >
                <ErrorBoundary>
                  <Suspense fallback={<LoaderComponent />}>
                    <Routes>
                      {loginPages.map((route) => (
                        <Route
                          key={route.path}
                          path={route.path}
                          element={
                            <ErrorBoundary>{route.element}</ErrorBoundary>
                          }
                          errorElement={<ErrorBoundary />}
                        />
                      ))}
                    </Routes>
                  </Suspense>
                </ErrorBoundary>
              </div>
            </Content>
          </Layout>
        </ConfigProvider>
      )}
    </Layout>
  );
};

export default LayoutComponent;
